import {createAction} from 'redux-actions'
import {urlListaProductosMenu, urlServicios} from "../../constants/urls";

// actions para productos
export const hasError = createAction('PRODUCTOS_MENU_HAS_ERROR');
export const isLoading = createAction('PRODUCTOS_MENU_IS_LOADING');
export const data = createAction('SET_DATA_PRODUCTOS_MENU');
export const setDataUrlRenovaciones = createAction('SET_DATA_URL_RENOVACIONES');

// actions para servicios
export const setDataServicios = createAction('SET_DATA_SERVICIOS');
export const setServiciosIsLoading = createAction('SET_SERVICIOS_IS_LOADING');
export const setServiciosHasError = createAction('SET_SERVICIOS_HAS_ERROR');

// fetch del menu de Servicios y manejo de redux
export const ServiciosMenuFetch = () => async (dispatch, getState) => {
  const state = getState();
  const date = state.rServicios.date;
  const now = new Date();
  if (date && date !== '' && now - date < 2 * 60 * 1000) {
    return;
  }
  dispatch(setServiciosIsLoading());
  await fetch(urlServicios)
    .then(response => response.json())
    .then(data => {
      console.log('data es lo siguiente ', data);
      if (data.transaccion) {
        const enlaces = data.enlaces.sort((enlaceA, enlaceB) => (enlaceA.parNombre > enlaceB.parNombre) ? 1 : -1)
        dispatch(setDataServicios(enlaces));
      }
    })
    .catch((e) => {
      dispatch(setServiciosHasError(`Error al consultar el menu de servicios: ${e}`));
    });
};

// fetch del menu de Productos y manejo de redux
export const ProductosMenuFetch = () => async (dispatch, getState) => {
  const state = getState();
  const date = state.datosProductosMenu.date;
  const now = new Date();
  if (date && date !== '' && now - date < 2 * 60 * 1000) {
    return;
  }
  dispatch(isLoading());
  //console.log('urlListaProductosMenu', urlListaProductosMenu)
  await fetch(urlListaProductosMenu)
    .then(response => response.json())
    .then(dato => {
      console.log(dato)

      const {transaccion, ramos, urlRenovaciones} = dato;
      if (transaccion) {
        dispatch(data(ramos));
        if (urlRenovaciones) {
          dispatch(setDataUrlRenovaciones(urlRenovaciones));
        }
      }
    })
    .catch((e) => {
      //console.log(e)
      dispatch(hasError('Error al consultar menus'));
    });
};
